module.exports = __webpack_public_path__ + "static/media/Image 557.04cd027a.png";